/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Protocol_Beginner_Deload_3_1_NameInputs */

const en_us2_protocol_beginner_deload_3_1_name = /** @type {(inputs: Protocol_Beginner_Deload_3_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beginner · 1 lighter week in 4`)
};

const pt_br2_protocol_beginner_deload_3_1_name = /** @type {(inputs: Protocol_Beginner_Deload_3_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciante · 1 semana leve a cada 4`)
};

const es_419_protocol_beginner_deload_3_1_name = /** @type {(inputs: Protocol_Beginner_Deload_3_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principiante · 1 semana ligera de cada 4`)
};

const pt_pt2_protocol_beginner_deload_3_1_name = /** @type {(inputs: Protocol_Beginner_Deload_3_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principiante · 1 semana leve em cada 4`)
};

const fr_fr2_protocol_beginner_deload_3_1_name = /** @type {(inputs: Protocol_Beginner_Deload_3_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débutant · 1 semaine légère sur 4`)
};

const de_de2_protocol_beginner_deload_3_1_name = /** @type {(inputs: Protocol_Beginner_Deload_3_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anfänger · 1 leichtere Woche von 4`)
};

const it_it2_protocol_beginner_deload_3_1_name = /** @type {(inputs: Protocol_Beginner_Deload_3_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principiante · 1 settimana leggera ogni 4`)
};

/**
* | output |
* | --- |
* | "Beginner · 1 lighter week in 4" |
*
* @param {Protocol_Beginner_Deload_3_1_NameInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const protocol_beginner_deload_3_1_name = /** @type {((inputs?: Protocol_Beginner_Deload_3_1_NameInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Protocol_Beginner_Deload_3_1_NameInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_protocol_beginner_deload_3_1_name(inputs)
	if (locale === "es-419") return es_419_protocol_beginner_deload_3_1_name(inputs)
	if (locale === "pt-PT") return pt_pt2_protocol_beginner_deload_3_1_name(inputs)
	if (locale === "fr-FR") return fr_fr2_protocol_beginner_deload_3_1_name(inputs)
	if (locale === "de-DE") return de_de2_protocol_beginner_deload_3_1_name(inputs)
	if (locale === "it-IT") return it_it2_protocol_beginner_deload_3_1_name(inputs)
	return en_us2_protocol_beginner_deload_3_1_name(inputs)
});
export { protocol_beginner_deload_3_1_name as "protocol.beginner-deload-3-1.name" }